import React, { forwardRef } from 'react';
import r_spinner_animated from '../../../icons/r_spinner_animated';
import getRenderable from '../../../lib/getRenderable';
import Icon from '../Icon';
import { ButtonProps } from './types';
import { COLORS, TEXT_COLORS, FILLS, SIZES } from './constants';
import generateClasses from './generateClasses';

/**
 * @deprecated Please use Button or ThemedButton from @fiverr-private/button instead.
 */
const Button = forwardRef<HTMLButtonElement | HTMLAnchorElement, ButtonProps>(({
    children,
    href,
    disabled = false,
    color = 'green',
    textColor = 'green',
    fill = 'full',
    className: customClassName,
    size = 'medium',
    innerRef,
    loading = false,
    ...rest
}, ref) => {
    const Element: any = href ? 'a' : 'button';
    const className = generateClasses(
        color,
        textColor,
        disabled,
        fill,
        size,
        loading,
        customClassName
    );
    const extendedProps = {
        ...rest,
        ref: innerRef || ref,
        href
    };

    return (
        <Element className={className.main}
            disabled={disabled}
            {...extendedProps}>
            {getRenderable(children)}
            { loading && <Icon className={className.icon}>{r_spinner_animated}</Icon> }
        </Element>
    );
});

Button.displayName = 'Button';

Object.assign(Button, {
    COLORS,
    TEXT_COLORS,
    FILLS,
    SIZES
});

export default Button;
